const URL_PATH = process.env.NODE_ENV === "development" ? "" : "/view";

export const INDEX = `${URL_PATH}/`;
export const SOFT = `${URL_PATH}/soft.html`;
export const USER_CENTER = `${URL_PATH}/usercenter.html`;
export const USER_NEW_CENTER = `${URL_PATH}/usercenter_new_speed.html`;

export const MALL = `${URL_PATH}/mall.html`;
export const MALL_AREA = `${URL_PATH}/mallarea.html`;
export const MALL_PAY = `${URL_PATH}/mallpay.html`;
export const GAME_AREA = `${URL_PATH}/gamearea.html`;
export const GAME = `${URL_PATH}/game.html`;
export const LIZHI_URL = "//partner.lizhi.io/support/360";
export const EXTERNAL_GAME = "https://fun.360.cn/external/weishiGaming";

const buildNewMallHost = () => {
  switch (process.env.FE_DEV) {
    case "local":
      return "";
    case "development":
      return "https://mgr-sim.soft.360.cn";
    case "regression":
      return "https://mgr-pre.soft.360.cn";
    case "production":
      return "https://cdn-mgr.soft.360.cn";
    default:
      return "https://cdn-mgr.soft.360.cn";
  }
};
const SOFT_MALL_HOST =
  process.env.NODE_ENV === "development" ? "" : "//api.soft.360.cn";
const SOFT_NEW_MALL_HOST = buildNewMallHost();

const SOFT_HOST = "";
const USER_CENTER_HOST = "//infocenter.soft.360.cn";

export const indexData = `${SOFT_HOST}/static/json/index/index_1.0.json`;

export const showIds = `${SOFT_HOST}/cms/showids.json`;

export const jisuIndexData = `${SOFT_HOST}/static/json/index/index_jisu_1.0.json`;

export const screenAd = "//activity.soft.360.cn/ad/limit";

export const searchResult = "//baoku.360.cn/search/webSoftList";

export const userLoginData = "//login.360.cn/";

export const userLevel = `${USER_CENTER_HOST}/integral/view`;

export const userCheckInStatus = `${USER_CENTER_HOST}/integral/sstatus`;

export const checkIn = `${USER_CENTER_HOST}/integral/check`;

export const mallList = `${SOFT_MALL_HOST}/order/getlist`;

export const failOrder = `${SOFT_MALL_HOST}/order/fexist`;

export const purchaseList = "//api.pay.soft.360.cn/Order/List";

// export const rechargeList = "https://api.pay.soft.360.cn/Order/tList";

export const softInfo = `${SOFT_HOST}/static/baoku/json_7_0/`;

export const softBaikeInfo = `//intf.baike.360.cn/index.php`;

export const softPolls = "//q.soft.360.cn/get_polls.php";

export const pollsAdd = "//intf.baike.360.cn/index.php";

export const pollsTag = "//comment.soft.360.cn/tag/getTopSoftTag";

export const myScore = "//soft.baike.360.cn/poll/getUserPoll";

export const commentTag = "//comment.soft.360.cn/tag/getRandSoftTag";

export const comment = "//intf.baike.360.cn/index.php";

export const mallNav = `${SOFT_MALL_HOST}/item/indexcate`;

export const mallBanner = `${SOFT_MALL_HOST}/index/banner`;

export const mallHot = `${SOFT_MALL_HOST}/index/hot`;

export const mallCategory = `${SOFT_MALL_HOST}/index/region`;

export const mallArea = `${SOFT_MALL_HOST}/item/area`;

export const mallItems = `${SOFT_MALL_HOST}/item/get`;
export const newmallItems = `${SOFT_NEW_MALL_HOST}/main/cdn_client/v1/mall/goods_group_get`;
export const newsubmitOrder = `${SOFT_NEW_MALL_HOST}/main/client/v1/mall/order/gen`;

export const submitOrder = `${SOFT_MALL_HOST}/order/submit`;

export const checkOrder = `${SOFT_MALL_HOST}/order/info`;
export const checkNewOrder = `${SOFT_NEW_MALL_HOST}/main/client/v1/mall/order/query`;
export const getGoodSku = `${SOFT_NEW_MALL_HOST}/main/cdn_client/v1/mall/goods_sku_get`;

export const gameData = `${SOFT_HOST}/cms/client/getGameData.json`;

export const rankBanner = `${SOFT_HOST}/cms/client/getRank.json`;

export const rankList = "//baoku.360.cn/soft/rankboard";

export const cloudGameData = `${SOFT_HOST}/static/json/cloud_game/cloud_game_1.0.json`;

export const webGameData = `${SOFT_HOST}/static/json/web_game/web_game_1.0.json`;

export const pmpUrl = "https://show-g.mediav.com/s";
